var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPilates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3103 60.175C44.3103 65.4057 40.0594 69.6458 34.8155 69.6458C29.5717 69.6458 25.3208 65.4057 25.3208 60.175C25.3208 54.9442 29.5717 50.7039 34.8155 50.7039C40.0594 50.7039 44.3103 54.9442 44.3103 60.175Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3103 60.175C44.3103 65.4057 40.0594 69.6458 34.8155 69.6458C29.5717 69.6458 25.3208 65.4057 25.3208 60.175C25.3208 54.9442 29.5717 50.7039 34.8155 50.7039C40.0594 50.7039 44.3103 54.9442 44.3103 60.175Z",
    stroke: "url(#paint0_linear_16725_955)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.784 19L62.2214 55.5521C62.404 56.7795 62.4956 58.0185 62.4956 59.2593V59.7708C62.4956 61.0953 62.3564 62.416 62.0801 63.7114L61.7647 65.1909C61.6568 65.6969 61.487 66.1878 61.2591 66.6526L44.2827 101.264M66.0202 55.4442L100.967 70.041L104.505 71.5755C106.647 72.5046 108.279 74.3141 108.982 76.5358L126.68 132.994M60.2264 75.7448L92.6835 88.4817M92.6835 88.4817L76.1174 132.197M92.6835 88.4817L106.505 74.7713",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.784 19L62.2214 55.5521C62.404 56.7795 62.4956 58.0185 62.4956 59.2593V59.7708C62.4956 61.0953 62.3564 62.416 62.0801 63.7114L61.7647 65.1909C61.6568 65.6969 61.487 66.1878 61.2591 66.6526L44.2827 101.264M66.0202 55.4442L100.967 70.041L104.505 71.5755C106.647 72.5046 108.279 74.3141 108.982 76.5358L126.68 132.994M60.2264 75.7448L92.6835 88.4817M92.6835 88.4817L76.1174 132.197M92.6835 88.4817L106.505 74.7713",
    stroke: "url(#paint1_linear_16725_955)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_955",
    x1: 25.3208,
    y1: 50.7039,
    x2: 47.8795,
    y2: 57.1446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_955",
    x1: 44.2827,
    y1: 19,
    x2: 145.842,
    y2: 39.9065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilates);
export default __webpack_public_path__ + "static/media/Pilates.d1341ff90b98aadd508030b32c00edc4.svg";
export { ForwardRef as ReactComponent };